import { paymentLinkStatus } from "../enums";
import { IPaymentLink } from "../interfaces-and-types";

export const paymentLinksData: IPaymentLink[] = [
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac3",
    linkUrl: "https://pay.switchapp.com/online_tutoring/9udQ399_K4y7et8js",
    status: paymentLinkStatus.active,
    productName: "Hauling Services",
    description: "a payment link description",
    price: 5000.55,
    currency: "NGN",
    currencySymbol: "₦",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "b1456-5648cc43-5338cc43-237d0098-1ac3",
    linkUrl: "https://pay.switchapp.com/online_tutoring/9udQ399_K4y7et8js",
    status: paymentLinkStatus.active,
    productName: "Auto Maintenance",
    description: "a payment link description",
    price: 340.55,
    currency: "USD",
    currencySymbol: "$",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "d2456-5448cc43-5648cc43-237d0098-1ac3",
    linkUrl: "https://pay.switchapp.com/online_tutoring/9udQ399_K4y7et8js",
    status: paymentLinkStatus.deactivated,
    productName: "School Fees",
    description: "a payment link description",
    price: 3600.55,
    currency: "GBP",
    currencySymbol: "£",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a43d-5448cc43-5648cc43-237d0098-1ac3",
    linkUrl: "https://pay.switchapp.com/online_tutoring/9udQ399_K4y7et8js",
    status: paymentLinkStatus.deactivated,
    productName: "Cleaning Services",
    description: "a payment link description",
    price: 3600.55,
    currency: "GBP",
    currencySymbol: "£",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
];
